import { FaPlay, FaFilm, FaGem, FaClock, FaVideo, FaCheckCircle, FaLock, FaUnlock, FaStar } from 'react-icons/fa';
import { HiSparkles, HiLightningBolt } from 'react-icons/hi';
import { BsPlayCircleFill, BsCollectionPlayFill, BsStarFill } from 'react-icons/bs';
import { IoMdRocket } from 'react-icons/io';
import { Link } from 'react-router-dom';

function CourseVideosSection() {
  const courses = [
    {
      title: "Advance Payment Collection Course",
      subtitle: "Complete Payment Recovery Guide",
      icon: BsCollectionPlayFill,
      gradient: "from-purple-600 via-violet-600 to-indigo-600",
      accentGradient: "from-purple-400 to-violet-500",
      badgeColor: "bg-purple-900",
      buttonColor: "text-purple-600 hover:bg-purple-50",
      videos: "23+",
      duration: "8+ Hours",
      tag: "BESTSELLER",
      link: "/apc-videos"
    },
    {
      title: "11 STRATEGIES",
      subtitle: "Advanced Recovery Techniques",
      icon: BsCollectionPlayFill,
      gradient: "from-emerald-600 via-green-600 to-teal-600",
      accentGradient: "from-emerald-400 to-green-500",
      badgeColor: "bg-emerald-900",
      buttonColor: "text-emerald-600 hover:bg-emerald-50",
      videos: "18+",
      duration: "4+ Hours",
      tag: "POPULAR",
      link: "/apc-videos?tab=strategies"
    }
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 rounded-3xl p-8 sm:p-12 mb-10">
      {/* Background Decorations */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-10 left-10 w-64 h-64 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-indigo-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-violet-500/10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          {/* Top Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-5 py-2 rounded-full text-sm font-semibold mb-6">
            <HiLightningBolt className="text-amber-400" />
            <span>Lifetime Access Included</span>
            <HiSparkles className="text-amber-400" />
          </div>
          
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            <span className="bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-400 bg-clip-text text-transparent">
              Access Your Course Videos
            </span>
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Click on the courses below to start your journey to becoming a payment recovery expert 🚀
          </p>
        </div>
        
        {/* Course Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {courses.map((course, index) => (
            <div 
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl overflow-hidden hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-purple-500/20"
            >
              {/* Tag Badge */}
              <div className="absolute top-4 right-4 z-10">
                <span className="flex items-center gap-1 bg-gradient-to-r from-amber-500 to-orange-500 text-slate-900 px-3 py-1 rounded-full text-xs font-bold">
                  <BsStarFill />
                  {course.tag}
                </span>
              </div>
              
              {/* Top Section */}
              <div className={`relative bg-gradient-to-br ${course.gradient} p-8 text-center overflow-hidden`}>
                {/* Animated Background Pattern */}
                <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.1)_50%,transparent_75%)] bg-[length:20px_20px] opacity-30"></div>
                
                {/* Icon */}
                <div className="relative w-20 h-20 mx-auto mb-4 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <course.icon className="text-4xl text-white" />
                </div>
                
                {/* Title */}
                <h3 className="relative text-white text-2xl font-bold mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {course.title}
                </h3>
                
                {/* Badge */}
                <span className={`relative inline-flex items-center gap-2 ${course.badgeColor} text-white px-4 py-2 rounded-full text-sm font-semibold`}>
                  <FaGem className="text-amber-400" /> 
                  VIDEO COURSE
                </span>
                
                {/* Stats Row */}
                <div className="relative flex items-center justify-center gap-6 mt-4 text-white/80 text-sm">
                  <span className="flex items-center gap-1">
                    <FaVideo className="text-amber-400" />
                    {course.videos} Videos
                  </span>
                  <span className="flex items-center gap-1">
                    <FaClock className="text-amber-400" />
                    {course.duration}
                  </span>
                </div>
              </div>
              
              {/* Bottom Section */}
              <div className="p-6 text-center">
                <h4 className="text-white text-lg font-semibold mb-2">{course.title}</h4>
                <p className="text-white/60 mb-6">{course.subtitle}</p>
                
                {/* Features */}
                <div className="flex flex-wrap justify-center gap-3 mb-6">
                  <span className="flex items-center gap-1 bg-white/10 px-3 py-1 rounded-full text-white/70 text-xs">
                    <FaUnlock className="text-green-400" />
                    Full Access
                  </span>
                  <span className="flex items-center gap-1 bg-white/10 px-3 py-1 rounded-full text-white/70 text-xs">
                    <FaCheckCircle className="text-green-400" />
                    Certificate
                  </span>
                </div>
                
                {/* CTA Button */}
                <Link 
                  to={course.link}
                  className={`inline-flex items-center gap-3 bg-white ${course.buttonColor} px-8 py-4 rounded-2xl font-bold transition-all duration-300 group-hover:scale-105 shadow-lg`}
                >
                  <BsPlayCircleFill className="text-xl" />
                  Watch Now
                  <IoMdRocket className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          ))}
        </div>
        
        {/* Bottom Trust Text */}
        <div className="flex items-center justify-center gap-6 mt-10 text-white/50 text-sm">
          <span className="flex items-center gap-2">
            <FaCheckCircle className="text-green-400" />
            Instant Access
          </span>
          <span className="w-1 h-1 bg-white/30 rounded-full"></span>
          <span className="flex items-center gap-2">
            <FaLock className="text-amber-400" />
            Secure Platform
          </span>
          <span className="w-1 h-1 bg-white/30 rounded-full"></span>
          <span className="flex items-center gap-2">
            <BsStarFill className="text-amber-400" />
            4.9/5 Rating
          </span>
        </div>
      </div>
    </section>
  );
}

export default CourseVideosSection;
